/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../../../src/app/components/client/notifications/notifications.module';
import * as i2 from '../../../../../node_modules/angular2-modal/src/angular2-modal.ng-flat.ngfactory';
import * as i3 from '../../../../../node_modules/angular2-modal/plugins/bootstrap/src/angular2-modal-bootstrap.ng-flat.ngfactory';
import * as i4 from '../../../shared/components/tooltip/tooltip.component.ngfactory';
import * as i5 from './notifications.component.ngfactory';
import * as i6 from '@angular/common';
import * as i7 from '@angular/forms';
import * as i8 from 'angular2-modal';
import * as i9 from 'angular2-modal/plugins/bootstrap';
import * as i10 from '@angular/platform-browser';
import * as i11 from '../../../../../../src/app/providers/client-route-resolve.service';
import * as i12 from '@angular/router';
import * as i13 from '../../../../../../src/app/providers/auth.service';
import * as i14 from '../../../../../../src/app/components/client/shared/services/shared-client.service';
import * as i15 from '../../../../../../src/app/components/client/shared/services/shared-notification.service';
import * as i16 from '../../../../../../src/app/providers/auth-http.service';
import * as i17 from 'angular2-moment/moment.module';
import * as i18 from '../../../../../../src/app/shared/shared.module';
import * as i19 from '../../../../../../src/app/components/client/notifications/notifications.component';
import * as i20 from '../../../../../../src/app/providers/auth-guard-client.service';
import * as i21 from '../../../../../../src/app/providers/timezone-guard.service';
export const NotificationsModuleNgFactory:i0.NgModuleFactory<i1.NotificationsModule> = i0.ɵcmf(i1.NotificationsModule,
    ([] as any[]),(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i2.ModalOverlayNgFactory,i2.CSSBackdropNgFactory,i2.CSSDialogContainerNgFactory,
              i3.BSModalContainerNgFactory,i3.BSMessageModalNgFactory,i4.TooltipComponentNgFactory,
              i5.NotificationsComponentNgFactory]],[3,i0.ComponentFactoryResolver],
              i0.NgModuleRef]),i0.ɵmpd(4608,i6.NgLocalization,i6.NgLocaleLocalization,
          [i0.LOCALE_ID]),i0.ɵmpd(4608,i7.ɵi,i7.ɵi,([] as any[])),i0.ɵmpd(4608,i8.OverlayRenderer,
          i8.DOMOverlayRenderer,[i0.ApplicationRef,i0.Injector]),i0.ɵmpd(4608,i8.Overlay,
          i8.Overlay,[i8.OverlayRenderer,i0.Injector]),i0.ɵmpd(4608,i8.Modal,i9.Modal,
          [i8.Overlay]),i0.ɵmpd(4608,i9.Modal,i9.Modal,[i8.Overlay]),i0.ɵmpd(4608,
          i7.FormBuilder,i7.FormBuilder,([] as any[])),i0.ɵmpd(5120,i10.EVENT_MANAGER_PLUGINS,
          () => {
            return [new i8.ɵa()];
          },([] as any[])),i0.ɵmpd(4608,i11.ClientRouteResolve,i11.ClientRouteResolve,
          [i12.Router,i13.AuthService,i14.SharedClientService]),i0.ɵmpd(4608,i15.SharedNotificationService,
          i15.SharedNotificationService,[i16.AuthHttpClient]),i0.ɵmpd(512,i6.CommonModule,
          i6.CommonModule,([] as any[])),i0.ɵmpd(512,i7.ɵba,i7.ɵba,([] as any[])),
          i0.ɵmpd(512,i7.FormsModule,i7.FormsModule,([] as any[])),i0.ɵmpd(512,i17.MomentModule,
              i17.MomentModule,([] as any[])),i0.ɵmpd(512,i8.ModalModule,i8.ModalModule,
              ([] as any[])),i0.ɵmpd(512,i9.BootstrapModalModule,i9.BootstrapModalModule,
              ([] as any[])),i0.ɵmpd(512,i7.ReactiveFormsModule,i7.ReactiveFormsModule,
              ([] as any[])),i0.ɵmpd(512,i18.SharedModule,i18.SharedModule,([] as any[])),
          i0.ɵmpd(512,i12.RouterModule,i12.RouterModule,[[2,i12.ɵa],[2,i12.Router]]),
          i0.ɵmpd(512,i1.NotificationsModule,i1.NotificationsModule,([] as any[])),
          i0.ɵmpd(1024,i12.ROUTES,() => {
            return [[{path:'',component:i19.NotificationsComponent,canActivate:[i20.AuthGuardClientService,
                i21.TimezoneGuardService],resolve:{permissions:i11.ClientRouteResolve}}]];
          },([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2NsaWVudC9ub3RpZmljYXRpb25zL25vdGlmaWNhdGlvbnMubW9kdWxlLm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2NsaWVudC9ub3RpZmljYXRpb25zL25vdGlmaWNhdGlvbnMubW9kdWxlLnRzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./compiled/src/app/components/client/notifications/notifications.module.ngfactory.ts